import http from '../http'

export default {
    contacts(usuario) {
        return http.get(`/usuarios/${usuario}/skypark/contacts`)
    },
}